import WithRender from "../../templates/base/hiddenInputFieldsWithIds.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getIsPersonalizationNewPage"]),
    getHiddenInputsWithIds: function () {
      let result = {};
      if (!this.getIsPersonalizationNewPage) {
        result = {
          customizedProductId: {
            id: "customizedProductId",
            name: "customizedProductId",
            value: ""
          },
          customizedProductIdSaveFrame: {
            id: "customizedProductIdSaveFrame",
            name: "customizedProductIdSaveFrame",
            value: ""
          },
          pq_type: {
            id: "pq_type",
            name: "pq_type",
            value: ""
          }
        };
      }
      return result;
    }
  }
});
